import { useEffect, useState } from "react";
import { useGlobalDragNDropContext } from "../context";
import type { IGlobalDroppableBooleanOptions } from "../types";

export const useGlobalDroppableBooleanOptions = (options: boolean | IGlobalDroppableBooleanOptions) => {
  const {
    registerDragStart,
    registerDragUpdate,
    registerDragEnd,
    unregisterDragStart,
    unregisterDragUpdate,
    unregisterDragEnd,
  } = useGlobalDragNDropContext();
  const [value, setValue] = useState(false);

  useEffect(() => {
    if (typeof options !== "boolean") {
      const cleanUp: (() => void)[] = [];
      const { onDragStart, onDragUpdate } = options;
      if (onDragStart) {
        const ref = registerDragStart((...args) => setValue(onDragStart(...args)));
        cleanUp.push(() => unregisterDragStart(ref));
      }
      if (onDragUpdate) {
        const ref = registerDragUpdate((...args) => setValue(onDragUpdate(...args)));
        cleanUp.push(() => unregisterDragUpdate(ref));
      }
      const ref = registerDragEnd(() => setValue(false));
      cleanUp.push(() => unregisterDragEnd(ref));
      return () => cleanUp.forEach((unregister) => unregister());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  return typeof options === "boolean" ? options : value;
};
